module.exports = __webpack_public_path__ + "media/images/business/trial/img_flow-97ea85565cdea52c6ad2ddba809d0cc7.svg";